import React from 'react'

import { Dialog, snackbar } from 'components'
import { useApiCall } from 'hooks'

import { deleteCampaign } from '../api'

interface DeleteCampaignDialogProps {
  handleClose: () => void
  onDone: () => void
  campaignId: number
  campaignTitle: string
}

const DeleteCampaignDialog: React.FC<DeleteCampaignDialogProps> = ({
  handleClose,
  campaignId,
  campaignTitle,
  onDone,
}) => {
  const [deleteCampaignApi, isLoading] = useApiCall<number, void>(deleteCampaign)

  const onDeleteCampaign = async () => {
    try {
      await deleteCampaignApi(campaignId)
      onDone()
    } catch (err) {
      console.error(err)
      snackbar.show('No se pudo eliminar la campaña. Intente de nuevo.')
    }
  }

  return (
    <Dialog
      title={`¿Está seguro que desea eliminar la campaña "${campaignTitle}"?`}
      isOpen
      showActions
      onCancel={handleClose}
      isLoading={isLoading}
      okButtonText="Eliminar"
      okButtonProps={{ disabled: isLoading }}
      onAccept={onDeleteCampaign}
    />
  )
}

export { DeleteCampaignDialog }
